import { Chip, Box, CircularProgress } from "@mui/material";
import { useRelatedRecords } from "../../../api/useRelatedRecords";
import { useFields } from "../../../api/useFields";
import { findField } from "../../../utils/findField";

type PaymentMethodsChipsProps = {
    orderId: number | string;
};

export const PaymentMethodsChips = ({ orderId }: PaymentMethodsChipsProps) => {
    const { formatedFields, status: fieldsStatus } = useFields("orders_payments");
    const relatedPayments = useRelatedRecords("orders_payments", "*", "order", orderId, undefined, undefined, Infinity);

    if (fieldsStatus !== "success" || relatedPayments.isLoading) {
        return <CircularProgress size={16} />;
    }

    const payments = relatedPayments.data?.items || [];
    if (payments.length === 0) return null;

    const paymentMethodField = findField(formatedFields, "payment_method");
    const choices = paymentMethodField?.settings?.options?.choices || [];

    const getPaymentMethodLabel = (paymentMethod: string) => {
        const selectedChoice = choices.find((c: any) => c.value === paymentMethod);
        return selectedChoice?.text || paymentMethod;
    };

    return (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            {payments.map((payment: any) => (
                <Chip
                    key={payment.id}
                    label={getPaymentMethodLabel(payment.payment_method)}
                    size="small"
                    variant="outlined"
                />
            ))}
        </Box>
    );
};

